import { render, staticRenderFns } from "./phoneFooter.vue?vue&type=template&id=1aabd339&scoped=true&"
import script from "./phoneFooter.vue?vue&type=script&lang=js&"
export * from "./phoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./phoneFooter.vue?vue&type=style&index=0&id=1aabd339&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabd339",
  null
  
)

export default component.exports